export default __webpack_public_path__ + "static/media/category_9.c3f0ea32.png";